<template>
  <div class="presenter-view-filters">
    <div class="image-wrapper" @click="openClose">
      <rp-sprite class="filter-icon" name="filter_list"/>
    </div>
    <transition name="fade">
      <div class="filters-wrapper" v-show="showFilters">
        <div class="filter">
          <rp-sprite class="input-icon" name="lens" />
          <rp-multiselect
              v-model="iolModelsSelected"
              :options="multiselectIOLOptions"
              multiple
              @input="emitServerFilters" />
        </div>
        <div class="filter">
          <rp-sprite class="input-icon" name="filter_list" />
          <rp-multiselect
              v-model="countriesSelected"
              :options="countries"
              multiple
              @input="emitCountryFilter" />
        </div>
        <div class="filter">
          <rp-sprite class="input-icon" name="date_range" />
          <rp-multiselect
              v-model="dateSelected"
              :options="dates"
              label="name"
              keyProp="value"
              trackBy="name"
              closeOnSelect
              @input="emitServerFilters" />
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import Sprite from 'raypro_ui/src/components/ui/Sprite'
import Multiselect from 'raypro_ui/src/components/ui/inputs/Multiselect'
import {getIolModels} from 'raypro_ui/src/api/iols'

export default {
  name: 'PresenterViewFilters',

  components: {
    'rp-sprite': Sprite,
    'rp-multiselect': Multiselect
  },

  data() {
    return {
      showFilters: false,
      multiselectIOLOptions: [],
      iolModelsSelected: [],
      countriesSelected: [],
      dateSelected: '',
      dates: [
        {
          name: 'Last month',
          value: '30',
          id: 1
        },
        {
          name: 'Last 3 months',
          value: '90',
          id: 2
        },
        {
          name: 'Last 6 months',
          value: '180',
          id: 3
        },
        {
          name: 'Last 12 months',
          value: '365',
          id: 4
        },
        {
          name: 'All time',
          value: '',
          id: 5
        }
      ]
    }
  },

  props: {countries: Array},

  created() {
    this.getIolModels()
  },

  methods: {
    openClose() {
      this.showFilters = !this.showFilters
    },

    emitServerFilters() {
      this.$emit('onServerFilters', this.iolModelsSelected, this.dateSelected)
    },

    emitCountryFilter() {
      this.$emit('onCountryFilter', this.countriesSelected)
    },

    getIolModels() {
      getIolModels().then(({data}) => {
        this.iolModels = data
        this.multiselectIOLOptions = data.map((el) => {
          return el.model
        })
      })
    },
  }
}
</script>

<style lang="sass" scoped>
@import 'raypro_ui/src/styles/base/_variables.sass'

.presenter-view-filters
  display: flex
  flex-direction: column
  align-items: flex-end
  
  .image-wrapper
    padding: 10px
    background-color: white
    border-radius: 6px
    box-shadow: 0 0 5px 0px $color-shadow

    svg
      width: 30px
      height: 30px
      fill: $color-side-nav

  .filters-wrapper
    padding: 20px 10px 0
    background-color: white
    border-radius: 6px
    box-shadow: 0 0 5px 0px $color-shadow
    margin-top: 10px

    .filter
      display: flex
      align-items: center

      svg
        margin: 0 6px 17px 0
        width: 20px
        height: 20px
        fill: $color-side-nav

  &.mobile

    .image-wrapper

      svg
        width: 24px
        height: 24px

</style>


// WEBPACK FOOTER //
// src/components/PresenterViewFilters.vue